import React from 'react';
import styles from './scales.module.css';
import ScaleOptionGrid from './ScaleOptionGrid';
import ScaleDualChoice from './ScaleDualChoice';
import ScaleRegionTable from './ScaleRegionTable';
import ScaleFieldGroups from './ScaleFieldGroups';
import { SCALE_KINDS, findOption, selectedValues, toggleMultiple, toggleSingle } from '../../modules/scales/scaleValues';

/** Ajuda da opção marcada por extenso (no celular o tooltip pede toque longo). */
const SelectedHelp = ({ scale, value }) => {
  const option = scale.kind === SCALE_KINDS.SINGLE && value ? findOption(scale, value.value) : null;
  if (!option || !option.help) return null;
  return <span className={styles.help}><strong>{option.label}:</strong> {option.help}</span>;
};

/**
 * Entrada de uma escala, escolhida pelo tipo do catálogo. Recebe o valor e
 * devolve o valor novo inteiro em `onChange` (null quando nada fica marcado).
 * `readOnly` desenha a mesma entrada sem interação (prévia da configuração).
 */
const ScaleInput = ({ scale, value, onChange, readOnly = false, gender }) => {
  switch (scale.kind) {
    case SCALE_KINDS.DUAL:
      return <ScaleDualChoice scale={scale} value={value} onChange={onChange} readOnly={readOnly} gender={gender} />;
    case SCALE_KINDS.REGIONS:
      return <ScaleRegionTable scale={scale} value={value} onChange={onChange} readOnly={readOnly} gender={gender} />;
    case SCALE_KINDS.FIELDS:
      return <ScaleFieldGroups scale={scale} value={value} onChange={onChange} readOnly={readOnly} gender={gender} />;
    case SCALE_KINDS.MULTIPLE:
    case SCALE_KINDS.SINGLE: {
      const toggle = scale.kind === SCALE_KINDS.MULTIPLE
        ? (optionValue) => onChange(toggleMultiple(scale, value, optionValue))
        : (optionValue) => onChange(toggleSingle(value, optionValue));
      return (
        <>
          <ScaleOptionGrid
            options={scale.options}
            selected={selectedValues(scale, value)}
            onToggle={toggle}
            readOnly={readOnly}
            gender={gender}
          />
          <SelectedHelp scale={scale} value={value} />
        </>
      );
    }
    default:
      return null;
  }
};

export default ScaleInput;
